import {combineReducers} from 'redux';
import appStateReducer from "./app-state-reducer";
import inviteReducer from "./invite-reducer";

const rootReducer = combineReducers({
    appState:appStateReducer,
    invite:inviteReducer
});

export default rootReducer;